import React from 'react';
import { AutomationContainer, AutomationContent } from './Automation.styled';
import AppMixer from '../../components/AppMixer';

const Automation = ({ flowUuid }) => {
  return (
    <AutomationContainer>
      <AutomationContent>
        <AppMixer flowUuid={flowUuid} />
      </AutomationContent>
    </AutomationContainer>
  );
};

export default Automation; 